module.exports = {
	"articleTitle1": "A Variety of Vegetation: An analysis of meat-free options on and ...",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "No Thai!",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/news/tim-hortons-open-shop-south-u",
	"articleSnippet1": "Jan 9, 2011 ... University alum Ananth Pullela recently opened Jazzy Veggie, the ... No Thai's \nmenu, with locations on South University Avenue, North 4th ...",
	"articleSnippet2": "Dec 3, 2012 ... ... including No Thai! and a World of Beer, both of which are expected to open this \n... Employees at popular coffee shops in the South University ...",
	"foodRecommendations": [
		{
			"text": "The beef pad seyu is great with medium spice",
			"person": "Meng Shi"
		}
	],
	"articleTitle2": "Tim Hortons to open Thursday in Landmark",
	"address": "1300 S University Ave #3, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/160414/eyx.NEW_.NoThai.3.26.16.101.jpg?itok=9frib-EH",
			"author": "Elizabeth Xiong",
			"caption": ""
		}
	],
	"position": {
		"lat": 42.274589,
		"lng": -83.732817
	},
	"totalMisc": 1,
	"categories": {
		"bestofaa": 1,
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/nothaisouthu.json
// module id = 936
// module chunks = 0